import styled from 'styled-components';

export const SignInLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const MainContent = styled.section.attrs({ id: 'main-content' })`
  position: relative;
  padding-bottom: 50px;
  flex-grow: 1;
`;

export const StatusBanner = styled.div`
  width: 100%;
  padding: 15px;
  background-color: #000;
  color: #fff;
  text-align: center;
`;
